<template>
  <div class="player-wrapper">
    <iframe
      v-if="isYoutubeUrl"
      :height="videoHeight"
      width="100%"
      :src="mediaUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="rounded-2 black"
    />

    <video
      :hidden="isYoutubeUrl"
      ref="player"
      :height="videoHeight"
      width="100%"
      controls
      controlslist="nodownload"
      class="rounded-2 black"
    >
      <source :src="mediaUrl" />
    </video>

    <div
      v-if="!isPlaying && canPlay"
      class="play-button d-flex justify-center align-center hand-cursor"
      @click="togglePlayPause"
    >
      <div class="inner-circle d-flex justify-center align-center">
        <v-icon size="60" color="white">mdi-play</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    mediaUrl: String,
  },
  data() {
    return {
      player: null,
      isPlaying: false,
      canPlay: false,
    };
  },
  computed: {
    isYoutubeUrl() {
      const p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

      return this.mediaUrl && this.mediaUrl.match(p)
        ? this.mediaUrl.match(p)[1]
        : false;
    },
    videoHeight() {
      return this.$vuetify.breakpoint.xsOnly
        ? 200
        : this.$vuetify.breakpoint.mdAndDown
        ? 350
        : 400;
    },
  },
  watch: {
    mediaUrl(newValue) {
      this.isPlaying = false;
      this.canPlay = false;

      if (!this.isYoutubeUrl) {
        this.initPlayer();

        if (this.player) {
          this.player.src = newValue;
          this.player.load();
        }
      }
    },
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      if (!this.player) {
        this.player = this.$refs["player"];

        if (this.player) {
          this.player.addEventListener("canplay", () => {
            this.canPlay = true;
          });

          this.player.addEventListener("timeupdate", () => {
            if (this.player.ended) {
              this.$emit("onEnd");
            }
          });

          this.player.addEventListener("play", () => {
            this.isPlaying = true;
          });

          this.player.addEventListener("pause", () => {
            this.isPlaying = false;
          });
        }
      }
    },
    getYouTubeUrl() {
      if (this.mediaUrl) {
        const regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;

        const match = this.mediaUrl.match(regExp);
        if (match && match[2].length === 11) {
          return "https://www.youtube.com/embed/" + match[2] + "?autoplay=0";
        }
      }
    },
    togglePlayPause() {
      if (this.player) {
        if (this.player.paused) {
          this.player.play();
          this.isPlaying = true;
        } else {
          this.player.pause();
          this.isPlaying = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player-wrapper {
  position: relative;
  width: 100%;
}
.play-button {
  position: absolute;
  margin: auto auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 50%;
  height: 95px;
  width: 95px;
  background-color: rgba(89, 40, 229, 0.3);
}
.inner-circle {
  position: absolute;
  margin: auto auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 50%;
  height: 70px;
  width: 70px;
  background-color: rgba(89, 40, 229);
}
</style>
